
import { patientActionTypes } from './../constants/ApiConstants';

const initialState = {
  app_data: null,
  master_data: [],
  loading: false,
  loadingMasterData: false,
  loading_searchTagsSidePanel: false,
  loadingAuthDataList: false,
  saved_patientDetails: null,
  medical_history: [],
  patientSocialHistory: null,
  savedPatientSocialHistory: null,
  history_data: {},
  history_deleted: {},
  patient_illness_deleted: {},
  diagnosisList: null,
  saved_patientDiagnosis: null,
  patientDiagnosisDetail: null,
  diagnosis_deleted: {},

  vitalsList: null,
  vitalDetails: null,
  saved_vitalDetails: null,
  deleted_vitalDetails: null,

  lab_order_data: {},
  lab_orders: [],
  get_patientImmunizationList: null,
  get_patientImmunizationDetails: null,
  patient_immunization_added: {},
  patient_immunization_deleted: {},
  get_patient_guardian: {},
  post_patient_guardian: {},
  delete_patient_guardian: {},
  post_custom: {},

  // objects for patient medications ...
  saved_patientMedication: null,
  deleted_patientMedication: null,
  patientMedicationDetails: null,
  patientMedicationsList: null,

  allergies: [],
  allergyData: {},

  // objects for patient allergy
  allergiesList: null,
  allergyDetails: null,
  saved_allergyDetails: null,
  deleted_allergyDetails: null,

  // objects for patient authorizations
  authorizationList: null,
  authorizationDetails: null,
  saved_patientAuthorization: null,
  deleted_patientAuthorization: null,
  update_patientAuthorization_activeStatus: null,

  authorizations: [],
  post_favourite: {},
  patientInsurance: [],
  get_soap: {},
  get_custom: {},
  saved_soap: {},
  searched_ICDs: [],
  searched_CPTs: [],
  get_master_tags: [],
  masterCustomLabels: null,
  payerCptCodes: null,
  patientMenuShowStatus: false,
  patientPortalStatus: false,
  patientActiveStatus: false,
  clientLockStatus: false,
  postAddressMessage: null,
  patientMasterTags: null,
  patientDocumentDownload: {}, // Patient document listing preview
  uploaded_document_download: {}, // Uploaded_document_download
  delete_Uploaded_Document: {}, // Delete document upload
  patientsList: [],
  saved_Notes: null,
  deleted_Notes: null,
  preview_document_download: {},// preview_document_download
  userDocumentMasterFolderList: null,
  saved_userDocumentMasterFolderList: null,
  userDocumentMasterFolderDetails: null,

  userDocumentSubFolderList: null,
  saved_userDocumentSubFolderList: null,
  userDocumentSubFolderDetails: null,

  saved_MoveBatchDocumentsIntoFolder: null,
  inactivated_MoveBatchDocuments: null,
  deleted_MoveBatchDocuments: null,

  deleted_UserDocumentMasterFolder: null,
  deleted_UserDocumentSubFolder: null,
  patientLocationsList: null,
  get_availability_template_by_id : null,
  saved_availability_template : null,
};


export default (state = initialState, { type, payload }) => {
  switch (type) {
    case patientActionTypes.get_masterdata.REQUEST:
    case patientActionTypes.get_master_state_by_countryid.REQUEST:
    case patientActionTypes.get_all_tag.REQUEST:
    case patientActionTypes.list_medical_history.REQUEST:
    case patientActionTypes.delete_family_history.REQUEST:
    case patientActionTypes.get_patient_preference.REQUEST:
    case patientActionTypes.get_patient_address.REQUEST:
    case patientActionTypes.get_patientById.REQUEST:
    case patientActionTypes.post_patient_insured_person.REQUEST:
    case patientActionTypes.get_patient_insurance.REQUEST:
    case patientActionTypes.get_patient_labOrder.REQUEST:
    case patientActionTypes.delete_patient_labOrder.REQUEST:
    case patientActionTypes.get_patient_encounters.REQUEST:
    case patientActionTypes.delete_patient_guardian_action.REQUEST:
    case patientActionTypes.post_patient_illness.REQUEST:
    case patientActionTypes.get_patient_illness_action.REQUEST:
    case patientActionTypes.get_patient_guardian_action.REQUEST:
    case patientActionTypes.get_patient_custom.REQUEST:
    case patientActionTypes.post_favourite_action.REQUEST:
    case patientActionTypes.get_favourite_action.REQUEST:
    case patientActionTypes.post_patient_preference.REQUEST:
    case patientActionTypes.post_patient_soap.REQUEST:
    case patientActionTypes.get_patients.REQUEST:
    case patientActionTypes.get_ICD_byName.REQUEST:
    case patientActionTypes.get_CPT_byName.REQUEST:
    case patientActionTypes.get_all_patients.REQUEST:
    case patientActionTypes.get_patients_by_location.REQUEST:
    case patientActionTypes.create_claim.REQUEST:
    case patientActionTypes.get_master_tags.REQUEST:
    case patientActionTypes.get_master_custom_labels.REQUEST:
    case patientActionTypes.patch_patientportal_activation.REQUEST:
    case patientActionTypes.patch_patient_active_status.REQUEST:
    case patientActionTypes.patch_client_lock_status.REQUEST:
    case patientActionTypes.import_patient_ccda.REQUEST:
    case patientActionTypes.post_patient_tag.REQUEST:
    case patientActionTypes.post_patient_insurance.REQUEST:
    case patientActionTypes.patch_patient_excludefullypiad_status.REQUEST:      
      return {
        ...state,
        loading: true,
        saving: true,
      };
    case patientActionTypes.post_patient_address.REQUEST:
      return {
        ...state,
        loading: true,
        saving: true,
        get_patient_address: null,
      };
    case patientActionTypes.get_appConfig.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case patientActionTypes.get_appConfig.SUCCESS:
      return {
        ...state,
        loading: true,
        app_data: payload,
      };
    // special cases for reseting the initial states ...
    case patientActionTypes.get_patient_soap.REQUEST:
    case patientActionTypes.get_patient_soap.FAILURE:
      return {
        ...state,
        loading: true,
        get_soap: {},
      };

    case patientActionTypes.save_family_history.FAILURE:

      return {
        ...state,
        loading: false,
        saving: false,
      };
    case patientActionTypes.save_family_history.REQUEST:
      return {
        ...state,
        loading: true,
        saving: true,
      };
    case patientActionTypes.post_patient_LabOrder.REQUEST:
      return {
        ...state,
        loading: true,
        saving: true,
      };
    case patientActionTypes.post_patient_custom.REQUEST:
      return {
        ...state,
        loading: true,
        saving: true,
      };
    case patientActionTypes.post_patient_guardian_action.REQUEST:
      return {
        ...state,
        loading: true,
        saving: true,
      };
    case patientActionTypes.post_patient_insurance.FAILURE:
      return {
        ...state,
        loading: false,
        saving: false,
      };

    case patientActionTypes.get_patient_ByALPHABET.REQUEST:
      return {
        ...state,
        search_loading: true,
      };
    case patientActionTypes.new_patient.SUCCESS:
      if (state.master_data) {
        return {
          get_patient_ByFilter: state.get_patient_ByFilter,
          get_patient_ByALPHABET: state.get_patient_ByALPHABET,
          get_patient_by_tag: state.get_patient_by_tag,
          master_data: state.master_data,
          get_custom: {},
          loading: false,
        };
      }
      break;
    case patientActionTypes.get_masterdata.SUCCESS:
      return {
        ...state,
        loading: false,
        master_data: payload,
      };
    case patientActionTypes.get_patients.SUCCESS:
      return {
        ...state,
        loading: false,
        patientList: payload,
      };

    case patientActionTypes.get_all_patients.SUCCESS:
      return {
        ...state,
        loading: false,
        patientAll: payload,
      };
    case patientActionTypes.get_patients_by_location.SUCCESS:
      return {
        ...state,
        loading: false,
        patientAll: payload,
      };
    case patientActionTypes.get_patient_by_tag.REQUEST:
      return {
        ...state,
        loading_searchTagsSidePanel: true,
      };
    case patientActionTypes.get_patient_by_tag.SUCCESS:
      return {
        ...state,
        loading_searchTagsSidePanel: false,
        get_patient_by_tag: payload,
      };
    case patientActionTypes.get_master_state_by_countryid.SUCCESS:
      return {
        ...state,
        loading: false,
        masterStateByCountryId: payload,
      };
    case patientActionTypes.get_all_tag.SUCCESS:
      return {
        ...state,
        loading: false,
        tag_data: payload,
      };
    case patientActionTypes.get_patient_address.SUCCESS:
      return {
        ...state,
        get_patient_address: payload,
        loading: false,
      };
    case patientActionTypes.post_patientInsuranceDetails.REQUEST:
      return {
        ...state,
        loading: true,
        saved_patientInsuranceDetails: null,
      };
    case patientActionTypes.post_patientInsuranceDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_patientInsuranceDetails: payload,
      };
    case patientActionTypes.post_patient_insurance.SUCCESS:
      let addedData = payload.data.attributes;
      addedData['id'] = payload.data.id;
      let copyArray = state.patientInsurance.slice(0);
      if (state.patientInsurance && state.patientInsurance.length) {
        state.patientInsurance.filter((arr, i) => {
          if (arr.id === addedData.id) {
            copyArray[i] = addedData;
          } else {
            copyArray.push(addedData);
          }
          return copyArray;
        });
      } else if (!state.patientInsurance.length) {
        copyArray.push(addedData);
      }
      return {
        ...state,
        saved_insurance: payload,
        patientInsurance: copyArray,
        patient_insurance: copyArray,
        loading: false,
        saving: false,
      };
    case patientActionTypes.post_patient_insured_person.SUCCESS:
      return {
        ...state,
        saved_insured_person: payload,
        patientActiveInsuredPerson: payload,
        loading: false,
      };
    case patientActionTypes.post_patientdata.REQUEST:
    case patientActionTypes.get_patientdata.REQUEST:
      return {
        ...state,
        loading: true,
        saving: true,
      };
    case patientActionTypes.post_patientdata.SUCCESS:
      return {
        ...state,
        loading: false,
        saving: false,
        saved_patient: payload,
        get_custom: {},
      };
    case patientActionTypes.post_patientdata.FAILURE:
      return {
        ...state,
        loading: false,
        saving: false,
      };

    case patientActionTypes.post_patientDetails.REQUEST:
      return {
        ...state,
        loading: true,
        saved_patientDetails: null,
      };
    case patientActionTypes.post_patientDetails.SUCCESS:
    case patientActionTypes.post_patientDetails.FAILURE:
      return {
        ...state,
        loading: false,
        saved_patientDetails: payload,
      };
    case patientActionTypes.get_patientdata.SUCCESS:
      return {
        ...state,
        loading: false,
        get_patients: payload,
      };
    case patientActionTypes.get_patientDetailsById.REQUEST:
      return {
        ...state,
        loading: true,
        getPatientDetails: null,
      };
    case patientActionTypes.get_patientDetailsById.SUCCESS:
      return {
        ...state,
        loading: false,
        getPatientDetails: payload,
        // patientInfo: {
        //   PatientID: payload.data && payload.data.id,
        //   UserID: payload.data && payload.data.userID,
        // },
      };
    case patientActionTypes.get_patientById.SUCCESS:

      let address = []; //  Filter Patient Address
      if (payload.included.length) { // Filter only Address.
        payload.included.find((allData) => {
          if (allData.type === 'patient-address') {
            allData.attributes['AddressID'] = allData.id;
            address.push(allData.attributes);
          }
          return address;
        });
      }
      let phone = []; //  Filter Patient phone
      if (payload.included.length) { // Filter only Address.
        payload.included.find((allData) => {
          if (allData.type === 'phone-numbers') {
            allData.attributes['PhoneID'] = allData.id;
            phone.push(allData.attributes);
          }
          return phone;
        });
      }
      let insurance = []; //  Filter Patient Insurance
      payload.included.find((allData) => {
        if (allData.type === 'patient-insurance-details') {
          allData.attributes['id'] = allData.id;
          insurance.push(allData.attributes);
        }
        return insurance;
      });
      let activeInsurance = {}; //  Assign primary Insurance as Current Insurance
      // let insurancePlanTypes = state.patient.master_data.insurancePlanType;
      // let primaryInsurancePlan = insurancePlanTypes ? insurancePlanTypes.find((Obj) => Obj.value === 'Primary') : null;
      // let primaryInsurancePlanID = primaryInsurancePlan ? primaryInsurancePlan.id : 0;
      if (insurance.length) {
        insurance.filter((ins, i) => {
          if (ins.InsurancePlanTypeID === 9) {
            activeInsurance = ins;
          }
          return activeInsurance;
        });
      }
      let activeInsurancedPerson = {}; //  Assign primary Insurance as Current Insurance
      let insuredPerson = []; //  Filter Patient Insuranced Person
      payload.included.filter((allData) => {
        if (allData.type === 'insured-person') {
          allData.attributes['id'] = allData.id;
          insuredPerson.push(allData.attributes);
        }
        return insuredPerson;
      });
      if (insuredPerson.length) {
        activeInsurancedPerson = insuredPerson[0];
      }
      let guardian = []; //  Filter Patient Guardian
      payload.included.find((allData) => {
        if (allData.type === 'patient-guardian') {
          allData.attributes['id'] = allData.id;
          guardian.push(allData.attributes);
        }
        return guardian;
      });
      let authorization = []; //  Filter Patient Guardian
      payload.included.find((allData) => {
        if (allData.type === 'authorization') {
          allData.attributes['id'] = allData.id;
          authorization.push(allData.attributes);
        }
        return authorization;
      });
      let allPreferences = []; //  Filter Patient Insurance
      let latestPreference = {}; //  Filter Patient Insurance
      payload.included.map((allData, i) => {
        if (allData.type === 'patient-preference') {
          allData.attributes['id'] = allData.id;
          allPreferences.push(allData.attributes);
        }
        return allPreferences;
      });
      latestPreference = allPreferences.slice(-1).pop();
      let tags = []; //  Filter Insurance by patientId
      payload.included.filter((allData) => {
        if (allData.type === 'patient-tags') {
          allData.attributes['id'] = allData.id;
          tags.push(allData.attributes);
        }
        return tags;
      });
      let medication = []; //  Filter medication by patientId
      payload.included.filter((allData) => {
        if (allData.type === 'patient-medication') {
          allData.attributes['id'] = allData.id;
          medication.push(allData.attributes);
        }
        return medication;
      });
      let primaryDiagnosis = {}; //  Filter Primary Diagnosis by patientId
      payload.included.filter((allData) => {
        if ((allData.type === 'patient-diagnosis') && (allData.attributes.IsPrimary)) {
          allData.attributes['id'] = allData.id;
          primaryDiagnosis = allData.attributes;
        }
        return primaryDiagnosis;
      });
      return {
        ...state,
        loading: false,
        patient_complete_data: payload.included[3],
        get_patient_byid: payload,
        patient_byid: payload.data.attributes,
        patientInfo: payload.data.attributes,
        patientAddress: address,
        patientMedications: medication,
        patientPhone: phone,
        patientInsurance: insurance,
        patientPrimaryDiagnosis: primaryDiagnosis,
        patientActiveInsurance: activeInsurance,
        patientActiveInsuredPerson: activeInsurancedPerson,
        patientPreference: latestPreference || payload.data.attributes,
        patientTags: tags,
        patientAuthorization: authorization,
        patientIncludedData: payload.included,
        patientGuardian: guardian,
        patientId: payload.data.id,
      };
    //  Get Patient Address By Id Data
    case patientActionTypes.get_patientAddressById.REQUEST:
      return {
        ...state,
        get_patient_address: null,
        loading: true,
      };
    case patientActionTypes.get_patientAddressById.SUCCESS:
      return {
        ...state,
        get_patient_address: payload,
        loading: false,
      };
    //  Get Patient Phone By Id Data
    case patientActionTypes.get_patientPhoneById.REQUEST:
      return {
        ...state,
        get_patient_phone: null,
        loading: true,
      };
    case patientActionTypes.get_patientPhoneById.SUCCESS:
      return {
        ...state,
        get_patient_phone: payload,
        loading: false,
      };
    case patientActionTypes.get_patient_preference.SUCCESS:
      return {
        ...state,
        patient_preference: payload,
        loading: false,
      };
    case patientActionTypes.get_patient_ByALPHABET.SUCCESS:
      return {
        ...state,
        search_loading: false,
        get_patient_ByALPHABET: payload,
      };
    case patientActionTypes.get_patient_ByFilter.REQUEST:
      return {
        ...state,
        search_loading: true,
        get_patient_ByFilter: null,
      };
    case patientActionTypes.get_patient_ByFilter.SUCCESS:
      return {
        ...state,
        search_loading: false,
        get_patient_ByFilter: payload,
      };
    case patientActionTypes.get_patient_ByFilterWithTags.REQUEST:
      return {
        ...state,
        search_loading: true,
        get_patient_ByFilterWithTags: null,
      };
    case patientActionTypes.get_patient_ByFilterWithTags.SUCCESS:
      return {
        ...state,
        search_loading: false,
        get_patient_ByFilterWithTags: payload,
      };
    case patientActionTypes.list_medical_history.SUCCESS:
      return {
        ...state,
        medical_history: payload,
        loading: false,
      };
    case patientActionTypes.get_patientSocialHistoryByPatientId.REQUEST:
      return {
        ...state,
        loading: true,
        patientSocialHistory: null,
      };
    case patientActionTypes.get_patientSocialHistoryByPatientId.SUCCESS:
      return {
        ...state,
        loading: false,
        patientSocialHistory: payload,
      };
    case patientActionTypes.post_patient_social_history.REQUEST:
      return {
        ...state,
        loading: true,
        savedPatientSocialHistory: null,
      };
    case patientActionTypes.post_patient_social_history.SUCCESS:
      return {
        ...state,
        loading: false,
        savedPatientSocialHistory: payload,
      };
    case patientActionTypes.post_patient_illness.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_patient: payload,
      };
    case patientActionTypes.post_patient_illness.FAILURE:
      return {
        ...state,
        loading: false,
      };
    case patientActionTypes.get_patient_illness_action.SUCCESS:
      return {
        ...state,
        loading: false,
        get_patient_illness: payload,
      };
    case patientActionTypes.save_family_history.SUCCESS:
      return {
        ...state,
        history_created: payload,
        loading: false,
        saving: false,
      };
    case patientActionTypes.get_patientDiagnosisDetail.REQUEST:
      return {
        ...state,
        loading: true,
        patientDiagnosisDetail: null,
      };
    case patientActionTypes.get_patientDiagnosisDetail.SUCCESS:
      return {
        ...state,
        loading: false,
        patientDiagnosisDetail: payload,
      };
    case patientActionTypes.post_patientDiagnosis.REQUEST:
      return {
        ...state,
        loading: true,
        saved_patientDiagnosis: null,
      };
    case patientActionTypes.post_patientDiagnosis.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_patientDiagnosis: payload,
      };
    case patientActionTypes.delete_family_history.SUCCESS:
      return {
        ...state,
        history_deleted: payload,
        loading: false,
      };
    case patientActionTypes.delete_patient_illness_action.SUCCESS:
      return {
        ...state,
        patient_illness_deleted: payload,
        loading: false,
      };
    // custom action types for patient medications ...
    case patientActionTypes.get_patientMedicationsList.REQUEST:
      return {
        ...state,
        loading: true,
        patientMedicationsList: null,
      };
    case patientActionTypes.get_patientMedicationsList.SUCCESS:
      return {
        ...state,
        loading: false,
        patientMedicationsList: payload,
      };
    case patientActionTypes.post_patientMedication.REQUEST:
      return {
        ...state,
        loading: true,
        saved_patientMedication: null,
      };
    case patientActionTypes.post_patientMedication.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_patientMedication: payload,
      };
    case patientActionTypes.get_patientMedicationsDetails.REQUEST:
      return {
        ...state,
        loading: true,
        patientMedicationDetails: null,
      };
    case patientActionTypes.get_patientMedicationsDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        patientMedicationDetails: payload,
      };
    case patientActionTypes.delete_patientMedication.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_patientMedication: null,
      };
    case patientActionTypes.delete_patientMedication.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_patientMedication: payload,
      };
    case patientActionTypes.delete_patient_address_action.SUCCESS:
      return {
        ...state,
        patient_address_deleted: payload,
        loading: false,
      };
    case patientActionTypes.get_patientDiagnosisList.REQUEST:
      return {
        ...state,
        loading: true,
        diagnosisList: null,
      };
    case patientActionTypes.get_patientDiagnosisList.SUCCESS:
      return {
        ...state,
        loading: false,
        diagnosisList: payload,
      };
    case patientActionTypes.delete_diagnosis_data.REQUEST:
      return {
        ...state,
        loading: true,
        diagnosis_deleted: null,
      };
    case patientActionTypes.delete_diagnosis_data.SUCCESS:
      return {
        ...state,
        loading: false,
        diagnosis_deleted: payload,
      };
    case patientActionTypes.get_patient_immunization_action.REQUEST:
      return {
        ...state,
        loading: true,
        get_patientImmunizationList: null,
      };
    case patientActionTypes.get_patient_immunization_action.SUCCESS:
      return {
        ...state,
        loading: false,
        get_patientImmunizationList: payload,
      };
    case patientActionTypes.get_patient_immunization_byId.REQUEST:
      return {
        ...state,
        loading: true,
        get_patientImmunizationDetails: null,
      };
    case patientActionTypes.get_patient_immunization_byId.SUCCESS:
      return {
        ...state,
        loading: false,
        get_patientImmunizationDetails: payload,
      };
    case patientActionTypes.post_patient_immunization.REQUEST:
      return {
        ...state,
        loading: true,
        patient_immunization_added: null,
      };
    case patientActionTypes.post_patient_immunization.SUCCESS:
      return {
        ...state,
        loading: false,
        patient_immunization_added: payload,
      };
    case patientActionTypes.post_patient_immunization.FAILURE:
      return {
        ...state,
        loading: false,
        patient_immunization_added: null,
      };

    // custom action types form patient vitals ...
    case patientActionTypes.get_patientVitalsList.REQUEST:
      return {
        ...state,
        loading: true,
        vitalsList: null,
      };
    case patientActionTypes.get_patientVitalsList.SUCCESS:
      return {
        ...state,
        loading: false,
        vitalsList: payload,
      };
    case patientActionTypes.get_patientVitalDetails.REQUEST:
      return {
        ...state,
        loading: true,
        vitalDetails: null,
      };
    case patientActionTypes.get_patientVitalDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        vitalDetails: payload,
      };
    case patientActionTypes.post_patientVital.REQUEST:
      return {
        ...state,
        loading: true,
        saved_vitalDetails: null,
      };
    case patientActionTypes.post_patientVital.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_vitalDetails: payload,
      };
    case patientActionTypes.delete_patientVital.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_vitalDetails: null,
      };
    case patientActionTypes.delete_patientVital.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_vitalDetails: payload,
      };
    case patientActionTypes.get_patient_labOrder.SUCCESS:
      return {
        ...state,
        loading: false,
        lab_orders: payload,
      };
    case patientActionTypes.post_patient_LabOrder.SUCCESS:
      return {
        ...state,
        loading: false,
        lab_order_data: payload,
        saving: false,
      };
    case patientActionTypes.post_patient_LabOrder.FAILURE:
      return {
        ...state,
        loading: false,
        saving: false,
      };
    case patientActionTypes.delete_patient_labOrder.SUCCESS:
      return {
        ...state,
        loading: false,
        lab_order_data: payload,
      };
    case patientActionTypes.delete_patient_immunization_action.REQUEST:
      return {
        ...state,
        patient_immunization_deleted: null,
        loading: true,
      };
    case patientActionTypes.delete_patient_immunization_action.SUCCESS:
      return {
        ...state,
        patient_immunization_deleted: payload,
        loading: false,
      };
    case patientActionTypes.get_patientAddressPhoneDetails.REQUEST:
      return {
        ...state,
        loading: true,
        patientAddressPhoneDetails: null,
      };
    case patientActionTypes.get_patientAddressPhoneDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        patientAddressPhoneDetails: payload,
      };
    case patientActionTypes.post_patientAddressPhoneDetails.REQUEST:
      return {
        ...state,
        loading: true,
        saved_patientAddressPhoneDetails: null,
      };
    case patientActionTypes.post_patientAddressPhoneDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_patientAddressPhoneDetails: payload,
      };
    case patientActionTypes.post_patient_address.SUCCESS:
      return {
        ...state,
        saved_patient_address: payload.response,
        loading: false,
        saving: false,
        postAddressMessage: payload.message,
      };
    case patientActionTypes.post_patient_tag.SUCCESS:
      return {
        ...state,
        saved_patient_tag: payload,
        loading: false,
        saving: false,
      };
    case patientActionTypes.get_patientInsuranceDetails.REQUEST:
      return {
        ...state,
        loading: true,
        patientInsuranceDetails: null,
      };
    case patientActionTypes.get_patientInsuranceDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        patientInsuranceDetails: payload,
      };
    case patientActionTypes.get_patient_insurance.SUCCESS:
      let insuranceData = []; //  Filter Patient Insurance
      payload.data.map((allData) => {
        if (allData.type === 'patient-insurance-details') {
          allData.attributes['id'] = allData.id;
          insuranceData.push(allData.attributes);
        }
        return insuranceData;
      });
      return {
        ...state,
        patient_insurance: insuranceData,
        loading: false,
      };
    case patientActionTypes.get_patient_insurance_byid.REQUEST:
      return {
        ...state,
        patientInsuranceList: null,
        loading: false,
      };
    case patientActionTypes.get_patient_insurance_byid.SUCCESS:
      return {
        ...state,
        patientInsuranceList: payload,
        loading: false,
      };
    case patientActionTypes.get_patient_current_insurance.SUCCESS:
      return {
        ...state,
        currentInsuranceDetails: payload,
        loading: false,
      };
    case patientActionTypes.get_patient_current_insured_person.SUCCESS:
      return {
        ...state,
        patientActiveInsuredPerson: payload,
        loading: false,
      };
    case patientActionTypes.get_patientGuardianList.REQUEST:
      return {
        ...state,
        loading: true,
        patientGuardianList: null,
      };
    case patientActionTypes.get_patientGuardianList.SUCCESS:
      return {
        ...state,
        loading: false,
        patientGuardianList: payload,
      };
    case patientActionTypes.get_patientGuardianDetails.REQUEST:
      return {
        ...state,
        loading: true,
        patientGuardianDetails: null,
      };
    case patientActionTypes.get_patientGuardianDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        patientGuardianDetails: payload,
      };
    case patientActionTypes.post_patientGuardianDetails.REQUEST:
      return {
        ...state,
        loading: true,
        saved_patientGuardianDetails: null,
      };
    case patientActionTypes.post_patientGuardianDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_patientGuardianDetails: payload,
      };
    case patientActionTypes.delete_patientGuardianDetails.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_patientGuardianDetails: null,
      };
    case patientActionTypes.delete_patientGuardianDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_patientGuardianDetails: payload,
      };
    case patientActionTypes.get_patient_guardian_action.SUCCESS:
      return {
        ...state,
        loading: false,
        get_patient_guardian: payload,
      };
    case patientActionTypes.post_patient_guardian_action.SUCCESS:
      return {
        ...state,
        loading: false,
        saving: false,
        post_patient_guardian: payload,
      };
    case patientActionTypes.post_patient_guardian_action.FAILURE:
      return {
        ...state,
        loading: false,
        saving: false,
      };
    case patientActionTypes.delete_patient_guardian_action.SUCCESS:
      return {
        ...state,
        delete_patient_guardian: payload,
        loading: false,
      };
    case patientActionTypes.get_patient_custom.SUCCESS:
      return {
        ...state,
        loading: false,
        get_custom: payload,
      };
    case patientActionTypes.post_patient_custom.SUCCESS:
      return {
        ...state,
        loading: false,
        post_custom: payload,
        saving: false,
      };
    case patientActionTypes.post_patient_custom.FAILURE:
      return {
        ...state,
        loading: false,
        saving: false,
      };
    case patientActionTypes.get_patient_encounters.SUCCESS:
      return {
        ...state,
        encounters: payload,
        loading: false,
      };
    case patientActionTypes.get_patient_single_encounters.REQUEST:
      return {
        ...state,
        singleEncounter: null,
        loading: true,
      };
    case patientActionTypes.get_patient_single_encounters.SUCCESS:
      return {
        ...state,
        singleEncounter: payload.data,
        loading: false,
      };
    case patientActionTypes.get_nonBillableEncounterDetails.REQUEST:
      return {
        ...state,
        nonBillableEncouterDetails: null,
        loading: true,
      };
    case patientActionTypes.get_nonBillableEncounterDetails.SUCCESS:
      return {
        ...state,
        nonBillableEncouterDetails: payload,
        loading: false,
      };

    // action types for patient allergy .
    case patientActionTypes.get_patientAllergiesList.REQUEST:
      return {
        ...state,
        loading: true,
        allergiesList: null,
      };
    case patientActionTypes.get_patientAllergiesList.SUCCESS:
      return {
        ...state,
        loading: false,
        allergiesList: payload,
      };
    case patientActionTypes.post_patientAllergy.REQUEST:
      return {
        ...state,
        loading: true,
        saved_allergyDetails: null,
      };
    case patientActionTypes.post_patientAllergy.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_allergyDetails: payload,
      };
    case patientActionTypes.get_patientAllergyDetails.REQUEST:
      return {
        ...state,
        loading: true,
        allergyDetails: null,
      };
    case patientActionTypes.get_patientAllergyDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        allergyDetails: payload,
      };
    case patientActionTypes.delete_patientAllergy.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_allergyDetails: null,
      };
    case patientActionTypes.delete_patientAllergy.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_allergyDetails: payload,
      };
    case patientActionTypes.get_patientAuthorizationList.REQUEST:
      return {
        ...state,
        loadingAuthDataList: true,
        authorizationList: null,
      };
    case patientActionTypes.get_patientAuthorizationList.SUCCESS:
      return {
        ...state,
        loadingAuthDataList: false,
        authorizationList: payload,
      };
    case patientActionTypes.get_patientAuthorizationDetails.REQUEST:
      return {
        ...state,
        loading: true,
        authorizationDetails: null,
      };
    case patientActionTypes.get_patientAuthorizationDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        authorizationDetails: payload,
      };
    case patientActionTypes.post_favourite_action.SUCCESS:
      return {
        ...state,
        loading: false,
        post_favourite: payload,
      };
    case patientActionTypes.post_favourite_action.FAILURE:
      return {
        ...state,
        loading: false,
      };
    case patientActionTypes.get_favourite_action.SUCCESS:
      return {
        ...state,
        loading: false,
        get_favourite_data: payload,
      };
    case patientActionTypes.post_patientAuthorization.REQUEST:
      return {
        ...state,
        loading: true,
        saved_patientAuthorization: null,
      };
    case patientActionTypes.post_patientAuthorization.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_patientAuthorization: payload,
      };

    case patientActionTypes.get_patientAuthorizationDetails.REQUEST:
      return {
        ...state,
        loading: true,
        update_patientAuthorization_activeStatus: null,
      };
    case patientActionTypes.get_patientAuthorizationDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        update_patientAuthorization_activeStatus: payload,
      };

    case patientActionTypes.delete_patientAuthorization.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_patientAuthorization: null,
      };
    case patientActionTypes.delete_patientAuthorization.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_patientAuthorization: payload,
      };
    case patientActionTypes.post_patient_preference.SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case patientActionTypes.post_patient_soap.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_soap: payload,
      };
    case patientActionTypes.post_patient_soap.FAILURE:
      return {
        ...state,
        loading: false,
      };
    case patientActionTypes.get_patient_soap.SUCCESS:
      return {
        ...state,
        loading: false,
        get_soap: payload,
      };
    case patientActionTypes.get_ICD_byName.SUCCESS:
      return {
        ...state,
        loading: false,
        searched_ICDs: payload,
      };
    case patientActionTypes.get_CPT_byName.SUCCESS:
      return {
        ...state,
        loading: false,
        searched_CPTs: payload,
      };
    case patientActionTypes.create_claim.SUCCESS:
    case patientActionTypes.create_claim.FAILURE:
      return {
        ...state,
        loading: false,
      };
    case patientActionTypes.get_master_tags.SUCCESS:
      let masterTags = [];
      if (payload && payload.data) {
        payload.data.map((obj, index) => {
          masterTags.push({ id: parseInt(obj.id, 10), value: obj.attributes.value });
          return masterTags;
        });
      }
      return {
        ...state,
        loading: false,
        get_master_tags: masterTags,
        get_original_master_tags: payload.data,
      };
    case patientActionTypes.get_masterCustomLabels.REQUEST:
      return {
        ...state,
        loading: true,
        masterCustomLabels: null,
      };
    case patientActionTypes.get_masterCustomLabels.SUCCESS:
      return {
        ...state,
        loading: false,
        masterCustomLabels: payload,
      };
    case patientActionTypes.post_customLabelsValues.REQUEST:
      return {
        ...state,
        loading: true,
        saved_customLabelValues: null,
      };
    case patientActionTypes.post_customLabelsValues.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_customLabelValues: payload,
      };
    case patientActionTypes.get_master_custom_labels.SUCCESS:
      return {
        ...state,
        loading: false,
        masterCustomLabels: payload,
      };
    case patientActionTypes.get_patient_payer_service_codes.REQUEST:
      return {
        ...state,
        loading: true,
        payerCptCodes: null,
      };
    case patientActionTypes.get_patient_payer_service_codes.SUCCESS:
      return {
        ...state,
        loading: false,
        payerCptCodes: payload,
      };
    case patientActionTypes.patient_menu_show_status.SUCCESS:
      return {
        ...state,
        patientMenuShowStatus: payload,
      };
    case patientActionTypes.patch_patientportal_activation.SUCCESS:
      return {
        ...state,
        patientPortalStatus: payload,
        loading: false,
      };
    case patientActionTypes.patch_patient_active_status.SUCCESS:
      return {
        ...state,
        patientActiveStatus: payload,
        loading: false,
      };
    case patientActionTypes.patch_patient_excludefullypiad_status.SUCCESS:
      return {
        ...state,
        patientActiveStatus: payload,
        loading: false,
      };
    case patientActionTypes.patch_client_lock_status.SUCCESS:
      return {
        ...state,
        clientLockStatus: payload,
        loading: false,
      };
    case patientActionTypes.get_patient_masterdata.REQUEST:
      return {
        ...state,
        loadingMasterData: true,
        patientMasterData: null,
      };
    case patientActionTypes.get_patient_masterdata.SUCCESS:
      return {
        ...state,
        loadingMasterData: false,
        patientMasterData: payload,
      };
    case patientActionTypes.get_patient_profileDetails.REQUEST:
      return {
        ...state,
        loading: true,
        patientProfileDetails: null,
      };
    case patientActionTypes.get_patient_profileDetails.SUCCESS:
      let patientInfo = null;
      let patientData = payload.data;
      let patientDetails = patientData.patientInfo && patientData.patientInfo.length ? patientData.patientInfo[0] : {};
      patientInfo = {
        PatientID: patientDetails.patientID,
        UserID: patientDetails.userID,
      };
      return {
        ...state,
        loading: false,
        patientProfileDetails: payload,
        patientInfo: patientInfo,
      };
    case patientActionTypes.upload_patient_documents.REQUEST:
      return {
        ...state,
        loading: true,
        uploadDocumentObj: null,
      };
    case patientActionTypes.upload_patient_documents.SUCCESS:
      return {
        ...state,
        loading: false,
        uploadDocumentObj: payload,
      };
    case patientActionTypes.get_patient_master_tags.REQUEST:
      return {
        ...state,
        loading_patientTags: true,
        patientMasterTags: null,
      };
    case patientActionTypes.get_patient_master_tags.SUCCESS:
      return {
        ...state,
        loading_patientTags: false,
        patientMasterTags: payload,
      };
    case patientActionTypes.import_patient_ccda.SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case patientActionTypes.import_patient_ccda.FAILURE:
      return {
        ...state,
        loading: false,
      };
    case patientActionTypes.get_patient_document_download.REQUEST: // Patient document listing render
      return {
        ...state,
        loading: true,
        patientDocumentDownload: null,
      };
    case patientActionTypes.get_patient_document_download.SUCCESS: // Patient document listing preview
      return {
        ...state,
        patientDocumentDownload: payload,
        loading: false,
      };
    case patientActionTypes.uploaded_document_download.REQUEST: // Uploaded document download
      return {
        ...state,
        loading: true,
      };
    case patientActionTypes.uploaded_document_download.SUCCESS: // uploaded document download
      return {
        ...state,
        loading: false,
        uploaded_document_download: payload,
      };
    case patientActionTypes.preview_document_download.REQUEST: // Uploaded document download
      return {
        ...state,
        loading: true,
      };
    case patientActionTypes.preview_document_download.SUCCESS: // uploaded document download
      return {
        ...state,
        loading: false,
        preview_document_download: payload,
      };
    case patientActionTypes.delete_Uploaded_Document.REQUEST: // Delete Uploaded document
      return {
        ...state,
        loading: true,
      };
    case patientActionTypes.delete_Uploaded_Document.SUCCESS: // Delete Uploaded document
      return {
        ...state,
        loading: false,
        delete_Uploaded_Document: payload,
      };
    case patientActionTypes.get_PatientsList.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case patientActionTypes.get_PatientsList.SUCCESS:
      return {
        ...state,
        loading: false,
        patientsList: payload,
      };
      case patientActionTypes.Post_Patient_Internal_Notes.REQUEST:
        return {
          ...state,
          loading: true,     
          saved_Notes: null, 
        };
      case patientActionTypes.Post_Patient_Internal_Notes.SUCCESS:
        return {
          ...state,
          loading: false,  
          saved_Notes: payload,    
          };
      case patientActionTypes.Get_Patient_Internal_Notes.REQUEST:
        return {
          ...state,      
          loading: true,
          PatientInternalNotes: null,
        };
      case patientActionTypes.Get_Patient_Internal_Notes.SUCCESS:
        return {
          ...state,
          PatientInternalNotes: payload,
          loading: false,
        };
      case patientActionTypes.Delete_Patient_Internal_Notes.REQUEST:
        return {
          ...state,
          loading: true,   
          deleted_Notes: null,   
        };
      case patientActionTypes.Delete_Patient_Internal_Notes.SUCCESS:
        return {
          ...state,
          loading: false,      
          deleted_Notes: payload,
          };

      case patientActionTypes.Get_UserDocumentMasterFolder.REQUEST:
        return {
            ...state,
            loading: true,
            userDocumentMasterFolderList: null
        };
      case patientActionTypes.Get_UserDocumentMasterFolder.SUCCESS:
          return {
              ...state,
              loading: false,
              userDocumentMasterFolderList: payload
          };

      case patientActionTypes.Post_UserDocumentMasterFolder.REQUEST:
        return {
            ...state,
            loading: true,
            saved_userDocumentMasterFolderList: null
        };
      case patientActionTypes.Post_UserDocumentMasterFolder.SUCCESS:
          return {
              ...state,
              loading: false,
              saved_userDocumentMasterFolderList: payload
          };
      case patientActionTypes.Get_UserDocumentMasterFolderById.REQUEST:
        return {
            ...state,
            loading: true,
            userDocumentMasterFolderDetails: null
        };
      case patientActionTypes.Get_UserDocumentMasterFolderById.SUCCESS:
          return {
              ...state,
              loading: false,
              userDocumentMasterFolderDetails: payload
          };
      // case patientActionTypes.delete_userDocumentMasterFolder.REQUEST:
      //   return {
      //       ...state,
      //       loading: true,
      //       deleted_curriculumLibrariesList: null
      //   };
      // case patientActionTypes.delete_userDocumentMasterFolder.SUCCESS:
      //     return {
      //         ...state,
      //         loading: false,
      //         deleted_curriculumLibrariesList: payload
      //     };
      case patientActionTypes.Get_UserDocumentSubFolder.REQUEST:
        return {
            ...state,
            loading: true,
            userDocumentSubFolderList: null
        };
      case patientActionTypes.Get_UserDocumentSubFolder.SUCCESS:
          return {
              ...state,
              loading: false,
              userDocumentSubFolderList: payload
          };

      case patientActionTypes.Post_UserDocumentSubFolder.REQUEST:
        return {
            ...state,
            loading: true,
            saved_userDocumentSubFolderList: null
        };
      case patientActionTypes.Post_UserDocumentSubFolder.SUCCESS:
          return {
              ...state,
              loading: false,
              saved_userDocumentSubFolderList: payload
          };
      case patientActionTypes.Get_UserDocumentSubFolderById.REQUEST:
        return {
            ...state,
            loading: true,
            userDocumentSubFolderDetails: null
        };
      case patientActionTypes.Get_UserDocumentSubFolderById.SUCCESS:
          return {
              ...state,
              loading: false,
              userDocumentSubFolderDetails: payload
          };
      // case patientActionTypes.delete_userDocumentSubFolder.REQUEST:
      //   return {
      //       ...state,
      //       loading: true,
      //       deleted_curriculumLibrariesList: null
      //   };
      // case patientActionTypes.delete_userDocumentSubFolder.SUCCESS:
      //     return {
      //         ...state,
      //         loading: false,
      //         deleted_curriculumLibrariesList: payload
      //     };

    case patientActionTypes.post_MoveBatchDocumentsIntoFolder.REQUEST:
      return {
        ...state,
        loading: true,
        saved_MoveBatchDocumentsIntoFolder: null
      };
    case patientActionTypes.post_MoveBatchDocumentsIntoFolder.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_MoveBatchDocumentsIntoFolder: payload
      };

    case patientActionTypes.post_InactiveBatchDocuments.REQUEST:
      return {
        ...state,
        loading: true,
        inactivated_MoveBatchDocuments: null
      };
    case patientActionTypes.post_InactiveBatchDocuments.SUCCESS:
      return {
        ...state,
        loading: false,
        inactivated_MoveBatchDocuments: payload
      };
    case patientActionTypes.post_DeleteBatchDocuments.REQUEST:
      return {
        ...state,
        loading: true,
        deleted_MoveBatchDocuments: null
      };
    case patientActionTypes.post_DeleteBatchDocuments.SUCCESS:
      return {
        ...state,
        loading: false,
        deleted_MoveBatchDocuments: payload
      };
    case patientActionTypes.Delete_UserDocumentMasterFolderById.REQUEST:
      return {
        ...state,
        loading: true,   
        deleted_UserDocumentMasterFolder: null,   
      };
    case patientActionTypes.Delete_UserDocumentMasterFolderById.SUCCESS:
      return {
        ...state,
        loading: false,      
        deleted_UserDocumentMasterFolder: payload,
        };
    case patientActionTypes.Delete_UserDocumentSubFolderById.REQUEST:
      return {
        ...state,
        loading: true,   
        deleted_UserDocumentSubFolder: null,   
      };
    case patientActionTypes.Delete_UserDocumentSubFolderById.SUCCESS:
      return {
        ...state,
        loading: false,      
        deleted_UserDocumentSubFolder: payload,
        };
    case patientActionTypes.get_patientLocations.REQUEST:
      return {
        ...state,
        loading: true,
        patientLocationsList: null,
      };
    case patientActionTypes.get_patientLocations.SUCCESS:
      return {
        ...state,
        loading: false,
        patientLocationsList: payload,
      };
    case patientActionTypes.get_availability_template_by_id.REQUEST:
      return {
        ...state,
        loading: true,
        get_availability_template_by_id: null,
      };
    case patientActionTypes.get_availability_template_by_id.SUCCESS:
      return {
        ...state,
        loading: false,
        get_availability_template_by_id: payload,
      };
    case patientActionTypes.save_availability_template.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_availability_template: payload,
    };
    case patientActionTypes.save_availability_template.FAILURE:
      return {
        ...state,
        loading: false,
    };
    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/modules/patients/reducers/PatientReducer.js